import React from "react";
import { withRouter } from "react-router-dom";
import { Button } from "aible";
import Select from "react-select";
import styles from "./style.module.css";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

class Upload extends React.PureComponent {
  render() {
    const { isOpen, header, outcome, fileName, updateIsOpen, handleUpload, handleChangeOutcome } = this.props;

    return (
      <Dialog open={isOpen} onHide={() => updateIsOpen(false)}>
        <DialogContent>
          <DialogHeader className={styles.modalHeader}>
            <DialogTitle>{fileName}</DialogTitle>
          </DialogHeader>
          <div className={styles.body}>
            <div className={styles.outcomeText}>
              {
                "Choose a variable (outcome) that you might want to predict and Aible will tell you whether your data is sufficient to predict that variable."
              }
            </div>
            <Select
              placeholder="Select Outcome"
              options={header}
              value={outcome}
              onChange={(val) => handleChangeOutcome(val)}
            />
          </div>
          <DialogFooter>
            <Button type="secondary" onClick={() => updateIsOpen(false)}>
              {"Cancel"}
            </Button>
            <Button type="primary" onClick={() => handleUpload()}>
              {"Select Outcome"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }
}

export default withRouter(Upload);
